import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Banknote = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12.433 6.036c3.027-.71 4.444-.881 6.085-.569.833.159 1.482.978 1.482 1.823v8.645c0 .82-.766 1.408-1.563 1.23-1.38-.31-2.684-.175-5.44.46l-1.431.34c-3.024.71-4.443.88-6.084.568C4.615 18.368 4 17.59 4 16.71V8.065c0-.82.766-1.408 1.563-1.23 1.38.31 2.686.175 5.438-.46zm5.836.74c-1.396-.265-2.701-.106-5.542.56l-.87.208c-3.344.794-4.847.982-6.585.593l.061.012v8.561c0 .195.103.369.253.458l.08.037.065.018c1.396.266 2.703.107 5.54-.559l1.445-.341c2.95-.681 4.376-.826 6.012-.46l-.062-.014V7.29c0-.167-.122-.36-.266-.456l-.073-.04zM14 8.667a.667.667 0 01.078 1.33L14 10h-2a.666.666 0 00-.662.589l-.005.078v.665l2 .001a.667.667 0 01.078 1.33l-.078.004h-2v.665l.667.001a.667.667 0 01.078 1.33l-.078.004h-.667v.666a.667.667 0 01-1.329.078L10 15.333v-.667h-.667a.667.667 0 01-.077-1.328l.077-.005H10v-2.666a2 2 0 011.882-1.997L12 8.667h2z"
        id="banknote_a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="banknote_b" fill="#fff">
        <use xlinkHref="#banknote_a" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#banknote_a" />
      <g mask="url(#banknote_b)" fill={props.color || theme.palette.grey600}>
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
